import {createSlice} from '@reduxjs/toolkit'
import {createSelector} from 'reselect'
import {useSelector} from 'react-redux'

const initialState = {language: null}

const appSlice = createSlice({
    name: 'app',
    initialState: initialState,
    reducers: {
        setLanguage(state, action) {
            state.language = action.payload
        },
    },
})

export const {setLanguage} = appSlice.actions
export default appSlice.reducer

// Memoized selectors
const selectAppLanguage = (state) => state.app.language
const selectIsRtl = createSelector(selectAppLanguage, (language) => language === 'he')

export const useLanguage = () => useSelector(selectAppLanguage)
export const useIsRtl = () => useSelector(selectIsRtl)
